var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1B1C",
    d: "M13.2 7.1L9.6 3.5c-.3-.3-.3-.9 0-1.2.3-.3.8-.3 1.2 0l5 5.1c.1.1.2.2.2.3.1.2.1.4 0 .7-.1.1-.1.2-.2.3l-5 5.1c-.2.2-.3.3-.6.3s-.4-.1-.6-.3c-.3-.3-.3-.9 0-1.2l3.6-3.7H1.8c-.5 0-.8-.4-.8-.9s.3-.9.8-.9h11.4z"
  })));
};
export default SvgArrow;